module.exports = __webpack_public_path__ + "img/logo-vip.0797c6cd.svg";